import { RouteRecordRaw } from 'vue-router'

const authRoutes: RouteRecordRaw = {
  path: '/auth',
  name: 'Authentication',
  component: () => import('@/layouts/Authentication.vue'),
  children: [
    {
      path: '/profileSelection',
      name: 'ProfileSelection',
      component: () => import('@/views/Authentication/ProfileSelection.vue'),
      meta: {
        title: 'Profile Selection'
      }
    }
  ]
}

export default authRoutes
